<template>
  <div class="user">
    <div class="header">
      <a class="logo" href="javascript:;"  @click="$router.push('/')">
        <img src="../assets/img/logo.svg" alt="">
      </a>
      <!-- <a class="menu_btn" href="javascript:;">
        <img src="../assets/img/menu.png" alt="">
      </a> -->
      <a class="quit" href="javascript:;" @click="loginOut">
        退出
      </a>
    </div>
    <div class="content">
      <div class="tab_box_lv1">
        <ul>
          <li>
            <a href="javascript:;" class="tab_item" @click="$router.push({name:'user'})">
              我的面板
              <i></i>
            </a>
          </li>
          <li>
            <a href="javascript:;" class="tab_item" :class="{checked:true}">
              应用管理
              <i></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="report_detail">
        <div class="tit">
          {{params.title}}
        </div>
        <div class="tip_msg">
          <table cellpadding="0" border="0" width="100%">
            <tr>
              <td align="left" width="30%">作者 <span>admin</span></td>
              <td >发布时间 <span>2018-01-02</span></td>
              <td width="30%" align="right">浏览量 <span>{{params.hits}}</span></td>
            </tr>
          </table>
        </div>
        <div class="main" v-html="params.content">
        </div>
        <div class="operate">
          <a class="download" v-if="this.params.files&&this.params.files.length!=0" href="javascript:;" @click="download">点击下载附件</a>
          <div class="table">
            <table width="100%">
              <tr>
                <td style="width: 50%;">上一篇: <span class="has" @click="getPrevious(next.contentId)">{{previous.title}}</span></td>
                <td style="width: 50%;">下一篇: <span class="has" @click="getNext(next.contentId)">{{next.title}}</span></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
     <detail-footer></detail-footer>
  </div>
</template>

<script>
import DetailFooter from './_footer'

export default {
  components: {
    DetailFooter
  },
  data () {
    return {
      isChecked:'',
      params:{},
      currentPage:'',//当前内容所处的页码
      pageSize:'', //每页数量
      pagePosition:'', //当前内容在当前页的位置【从1开始】
      categoryId:'', //当前内容所在栏目ID
      next:{
        title:'没有了',
        contentId:''
      },
      previous:{
        title:'没有了',
        contentId:''
      }
    }
  },
  mounted() {
    this.isChecked = this.$route.query.contentId;
    this.currentPage = this.$route.query.currentPage;
    this.pageSize = this.$route.query.pageSize;
    this.pagePosition = this.$route.query.pagePosition;
    this.categoryId = this.$route.query.categoryId;
    this.getInfo(this.isChecked);
  },
  methods: {
    download(){
      if(this.params.files&&this.params.files.length!=0){
        this.$router.push({name:"result",query:{route:"industry-report-detail",fileId:this.params.files[0].id}});
      }
    },
    loginOut(){
      window.sessionStorage.removeItem("accentToken")
      this.$router.push("login");
    },
    getInfo(contentId) {
      this.$axios.post('/api/web/phone/content/detail/'+ contentId ,{
          currentPage:this.currentPage,
          pageSize:this.pageSize,
          pagePosition:this.pagePosition,
          categoryId:this.categoryId
      }).then((res)=>{
        this.params = res.data;
        if(!res.data.next){
          this.next.title = "没有了"
        }else{
          this.next = res.data.next;
        }
        if(!res.data.previous){
          this.previous.title = "没有了"
        }else{
          this.previous = res.data.previous;
        }
        
      })
    },
    getNext(contentId){
      if(this.pagePosition <= (this.pageSize-1)){
        this.pagePosition++;
      }else{
        this.pagePosition = 1;
        this.currentPage++;
      }
      this.getInfo(contentId);
    },
    getPrevious(contentId){
      if(this.pagePosition > 1){
        this.pagePosition--;
      }else if(this.pagePosition == 1 && this.currentPage >1){
        this.pagePosition = this.pageSize;
        this.currentPage--;
      }else if(this.pagePosition == 1 && this.currentPage ==1){
        return
      }
      
      this.getInfo(contentId);
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/sass/global.scss';

  .user {
    background: #F5F5F5;
    min-height: 100vh;
    box-sizing:border-box;
    position: relative;
  }
  .pl-75{
    padding-left: 75px;
  }
  .mt-15{
    margin-top: 15px;
  }
  .header{
    height: 54px;
    background: #fff;
    border-bottom: 2px solid #f5f5f5;
    top: 0;
    left: 0;
    right: 0;
    position:fixed;
    z-index: 99;
    .logo{
      display: inline-block;
      // width: 155px;
      // height: 24px;
      position: absolute;
      top: 15px;
      left: 15px;
      img{
        height: 35px;
      }
    }
    .menu_btn{
      display: inline-block;
      position: absolute;
      top: 13px;
      right: 13px;
      width: 29px;
      height: 29px;
      img{
        width:100%;
        height:100%;
      }
    }
    .quit{
      display: inline-block;
      position: absolute;
      top: 15px;
      right: 18px;
      color: #fff;
      font-size: 16px;
    }
  }
  .tab_box_lv1{
    height: 50px;
    background: #F5F5F5;
    ul{
      padding: 0;
      margin: 0;
      width: 100%;
      display: inline-block;
    }
    ul::after{
      content: ' ';
      clear: both;
    }
    ul li{
      margin: 0;
      display: inline-block;
      width: 50%;
      float: left;
      box-sizing: border-box;
    }
    .tab_item{
      display: inline-block;
      width: 100%;
      padding: 10px 0;
      color: #999999;
      font-size:20px;
      box-sizing: border-box;
      position: relative;
      i{
        width: 100%;
        height: 2px;
        position: absolute;
        bottom: 0;
        left: 0;
        background: #E0E0E0;
      }
    }
    .tab_item.checked{
      color: #64A9FF;
      i{
        background: #64A9FF;
      }
    }

  }

  .content {
    min-height: calc(100vh - 66px);
    box-sizing: border-box;
    padding-top: 54px;
    .report_detail{
      position: relative;
      padding: 0 15px;
      text-align: left;
      min-height: calc(100vh - 188px);
      padding-bottom: 80px;
      box-sizing: border-box;
      .tit{
        position: relative;
        padding-top: 15px;
        color: #333333;
        font-size: 16px;
        text-align: center;
      }
      .tip_msg{
        font-size: 13px;
        color: #666666;
        margin-top: 15px;
        span{
          color: #999999;
        }
      }
      .main{
        margin-top: 25px;
        color: #666666;
        font-size: 14px !important;
        /*p{
          margin-top: 15px;
        }*/
      }
      .operate{
        position: absolute;
        bottom: 0;
        left: 15px;
        right: 15px;
        height: 68px;
        .download{
          height:18px;
          font-size:13px;
          color:rgba(100,169,255,1);
          line-height:18px;
          display: inline-block;
        }
        .table{
          padding: 15px 0;
        }
        table td{
          height:18px;
          font-size:13px;
          color:rgba(102,102,102,1);
          line-height:18px;
          position: relative;
        }
        .has{
          width: 130px;
          position: absolute;
          height:18px;
          color: #64A9FF;
          display: inline-block;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }

    }
  }
  .footer{
    box-sizing: border-box;
    height: 66px;
    background: #0C324C;
    padding: 12px 0;
    li{
      color: #fff;
      font-size: 13px;
      height: 18px;
      span{
        width:6px;
        display: inline-block;
        text-align: center;
      }
      a{
        color: #fff;
      }
    }
    .footer_tip{
      margin-top: 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/industry-report-detail.vue